import moment from "moment";
import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import AddDetails from "./AddDetails";
import gameAPI from "../../../api/admin/gameApi";
import { formatDateOnly } from "../../../helper/Helper";
import { Link } from "react-router-dom";
import EditDetails from "./EditDetails";

function List() {
  const localizer = momentLocalizer(moment);
  const [events, setEvents] = useState([]);
  const [showEvents, setShowEvents] = React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [editData, setEditData] = useState(null);

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  useEffect(() => {
    fetchGameData();
  }, []);

  const fetchGameData = async () => {
    const res = await gameAPI.getList();
    if (res.code === 200) {
      setEvents(res.data);
    } else {
      setEvents([]);
    }
  };

  const handleShowModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-flex align-items-center justify-content-between gap-2 mb-4 flex-wrap">
            <div>
              <h4 className="mb-1">
                Game Calendar
                <span className="badge badge-soft-primary ms-2">
                  {events.length}
                </span>
              </h4>
              <h6 className="text-muted">
                View, search, and manage all Games available in your system.
              </h6>
            </div>
            <div className="gap-2 d-flex align-items-center flex-wrap">
              <button
                className="btn btn-primary mt-2 mt-md-0"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
                onClick={() => setShowOffcanvas(true)}
              >
                <i className="ti ti-circle-plus me-1" />
                Add Event
              </button>

              <button
                className="btn btn-outline-primary mt-2 mt-md-0"
                onClick={() => setShowEvents(!showEvents)}
              >
                {showEvents ? "Hide Events" : "Show All Events"}
              </button>
            </div>
          </div>

          <div className="row transition-all">
            <div
              className={
                showEvents
                  ? "col-md-8 transition-all"
                  : "col-md-12 transition-all"
              }
            >
              <div className="card">
                <div className="card-body">
                  <Calendar
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 600 }}
                    onSelectEvent={(event) => {
                      setSelectedEvent(event);
                      handleShowModal(event.id);
                    }}
                    eventPropGetter={(event) => ({
                      style: {
                        backgroundColor:
                          event.id === selectedEvent?.id
                            ? "#28a745"
                            : "#007bff",
                        borderColor:
                          event.id === selectedEvent?.id
                            ? "#28a745"
                            : "#007bff",
                      },
                    })}
                  />
                </div>
              </div>
            </div>

            {showEvents && (
              <div className="col-md-4 transition-all">
                <div className="card border-start" style={{ height: "630px" }}>
                  <div className="card-header">
                    <h5>All Events</h5>
                  </div>

                  <div className="card-body">
                    <ul className="list-group">
                      {events.map((item, key) => (
                        <div className="card event-card" key={key}>
                          <div className="card-header-custom">
                            <div className="d-flex justify-content-between align-items-center">
                              <h3 className="game-title">{item.title}</h3>

                              <Link
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasEditRight"
                                aria-controls="offcanvasEditRight"
                                className="me-2 p-2 sport-badge"
                                onClick={() => setEditData(item)}
                              >
                                <i className="ti ti-pencil" /> Edit
                              </Link>
                            </div>
                          </div>
                          
                          <div className="card-body">
                            <div className="row">
                              <div className="col-6">
                                <div className="date-label">Start Date</div>
                                <div className="date-value">
                                  <i className="fas fa-calendar-alt" />{" "}
                                  {formatDateOnly(item.start)}
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="date-label">End Date</div>
                                <div className="date-value">
                                  <i className="fas fa-calendar-check" />{" "}
                                  {formatDateOnly(item.end)}
                                </div>
                              </div>
                            </div>
                            <div className="venue-info">
                              <i className="fas fa-map-marker-alt" />
                              <strong>Venue:</strong> {item.venue}
                            </div>
                            <div className="venue-info">
                              <strong>Sports:</strong>{" "}
                              {item?.sports
                                ?.map((s) => s.sportId?.name)
                                .join(", ")}
                            </div>
                            <div
                              className="description"
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        {showOffcanvas && <AddDetails onSuccess={fetchGameData} />}
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasEditRight"
        aria-labelledby="offcanvasEditRightLabel"
      >
        {editData && <EditDetails data={editData} onSuccess={fetchGameData} />}
      </div>

      {/* {showModal && (
        <div className="modal-fade" id="add_folder">
          <AddDetails />
          {console.log(showModal)}
        </div>
      )} */}
    </>
  );
}

export default List;
